import { AdvertisementAsset, FileResult } from '@horasys/bellplus/common/types';

export const convertToFileAssetFromAdvertisementAsset = (
	advertisementAsset: AdvertisementAsset,
): FileResult => {
	const fileResult: FileResult = {} as FileResult;
	fileResult.fileName = advertisementAsset.originalFileName;
	fileResult.id = advertisementAsset.id;
	fileResult.url = advertisementAsset.url;
	fileResult.duration = advertisementAsset.duration;
	fileResult.mediaType = advertisementAsset.type;
	fileResult.source = advertisementAsset.source;
	fileResult.uploadStatus = '';
	return fileResult;
};

export const convertToAdvertisementAssetFromFileResult = (
	fileResult: FileResult,
	advertisementAsset: AdvertisementAsset,
): AdvertisementAsset => {
	const updatedAdvertisementAsset: AdvertisementAsset = { ...advertisementAsset };
	updatedAdvertisementAsset.id = fileResult.id;
	updatedAdvertisementAsset.duration = fileResult.duration;
	updatedAdvertisementAsset.originalFileName = fileResult.fileName;
	updatedAdvertisementAsset.url = fileResult.url;
	updatedAdvertisementAsset.uploadstatus = fileResult.uploadStatus;
	updatedAdvertisementAsset.source = fileResult.source;
	return updatedAdvertisementAsset;
};
